import { render, staticRenderFns } from "./priceConfiguration.vue?vue&type=template&id=dda372c6&scoped=true&"
import script from "./priceConfiguration.vue?vue&type=script&lang=js&"
export * from "./priceConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./priceConfiguration.vue?vue&type=style&index=0&id=dda372c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda372c6",
  null
  
)

export default component.exports